import { render, staticRenderFns } from "./WkUpload.vue?vue&type=template&id=3b98a5d8&scoped=true&"
import script from "./WkUpload.vue?vue&type=script&lang=js&"
export * from "./WkUpload.vue?vue&type=script&lang=js&"
import style0 from "./WkUpload.vue?vue&type=style&index=0&id=3b98a5d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b98a5d8",
  null
  
)

export default component.exports